import Navbar from "../components/Navbar/Navbar";
import { ManagementMenu } from "../data/ManagementMenu";

export const ManagementLayout = ({ children, handleShow, showCrmButton }) => {
  return (
    <>
      <Navbar
        menuList={ManagementMenu}
        Crm={showCrmButton}
        handleShow={handleShow}
        showCrmButton={showCrmButton}
      />
      {children}
    </>
  );
};
